
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M0 .974v5.842c0 .535.45.973 1 .973h6c.55 0 1-.438 1-.973V.974C8 .438 7.55 0 7 0H1C.45 0 0 .438 0 .974zm7 16.552H1c-.55 0-1-.438-1-.974V10.71c0-.535.45-.974 1-.974h6c.55 0 1 .439 1 .974v5.842c0 .536-.45.974-1 .974zm3-.974V10.71c0-.535.45-.974 1-.974h6c.55 0 1 .439 1 .974v5.842c0 .536-.45.974-1 .974h-6c-.55 0-1-.438-1-.974zm0-9.736V.974C10 .438 10.45 0 11 0h6c.55 0 1 .438 1 .974v5.842c0 .535-.45.973-1 .973h-6c-.55 0-1-.438-1-.973z","fill":"currentColor"}})])
          )
        }
      }
    